<template>
  <div>
    <v-container>
      <v-row align="center" class="text-center" v-if="!submitted">
        <v-col class="mb-8" cols="12">
          <h4 class="text-h4 blue--text text--darken-4">
            Let's see which services are available at your address.
          </h4>
        </v-col>
      </v-row>
      <v-row class="text-center justify-center" cols="12" v-if="!submitted">
        <v-col xs="12" sm="7" md="5" lg="4">
          <v-autocomplete
            autocomplete="off"
            shrink
            v-model="city"
            :items="cities"
            item-text="name"
            label="Choose your city"
            return-object
            clearable
            placeholder="Start typing to search"
            no-data-text="Not found. Clear the box to view choices."
          />
        </v-col>
      </v-row>
      <v-row
        class="text-center justify-center"
        v-if="city && !city.wireless && !submitted"
      >
        <v-col xs="12" sm="7" md="5" lg="4">
          <v-autocomplete
            autocomplete="off"
            shrink
            v-model="address"
            :items="addresses"
            item-text="address"
            label="Street address"
            placeholder="Start typing to search"
            no-data-text="Not found. Type a partial address to expand search."
            ref="addressAutocomplete"
            return-object
            clearable
          />
        </v-col>
      </v-row>
      <v-row
        class="text-center justify-center"
        v-if="city && address && !submitted"
      >
        <v-col xs="12" sm="7" md="5" lg="4">
          <v-select
            shrink
            v-model="business"
            :items="businessSelections"
            label="Is this property a residence or a business?"
          />
        </v-col>
      </v-row>
      <v-row
        class="text-center justify-center"
        v-if="city && (address || city.wireless) && !submitted"
      >
        <v-col>
          <v-btn @click="submit" dark color="blue darken-3">
            Check address
            <v-icon right dark>mdi-arrow-right-bold-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        class="text-center justify-center mt-8"
        v-if="city && address && !submitted"
      >
        <v-col>
          <iframe
            width="500"
            height="400"
            style="border: 0"
            loading="lazy"
            allowfullscreen
            :src="`https://www.google.com/maps/embed/v1/search?key=${googleMapsApiKey}&q=${address.address},${city.name}&zoom=15`"
          ></iframe>
        </v-col>
      </v-row>
      <v-row class="text-center justify-center mt-8" v-if="showUnlistedLink">
        <v-col>
          <v-btn @click="submitUnlisted" text color="orange darken-2">
            Not finding your address?
            <v-icon right>mdi-arrow-right-bold-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <Services
      v-if="address && submitted"
      :address="address"
      :city="city"
      :business="business"
      :googleMapsApiKey="googleMapsApiKey"
      @clearAddress="clearAddress"
    />
    <OutOfAreaServices
      v-if="city && city.wireless && submitted"
      :city="city"
      :business="business"
      @clearAddress="clearAddress"
    />
    <UnlistedAddressServices
      v-if="unlistedAddress && submitted"
      :city="city"
      @clearAddress="clearAddress"
    />
  </div>
</template>

<script>
import OutOfAreaServices from "./OutOfAreaServices";
import Services from "./Services";
import UnlistedAddressServices from "./UnlistedAddressServices";

export default {
  name: "AddressLookup",

  components: { OutOfAreaServices, Services, UnlistedAddressServices },

  mounted() {
    this.fetchCities();
  },

  data: () => ({
    address: null,
    addresses: [],
    business: false,
    businessSelections: [
      { text: "Residence", value: false },
      { text: "Business", value: true },
    ],
    cities: [],
    city: null,
    loading: false,
    submitted: false,
    unlistedAddress: false,
  }),
  methods: {
    fetchAddresses() {
      this.address = null;
      if (!this.city) {
        this.addresses = [];
      }
      this.$axios
        .get("/api/cities/" + this.city.id + "/service-addresses")
        .then(({ data }) => {
          this.addresses = data.service_addresses;
        })
        .catch(() => {
          this.addresses = [];
        })
        .then(() => {
          this.loading = false;
        });
    },
    fetchCities() {
      this.$axios
        .get("/api/cities")
        .then(({ data }) => {
          this.cities = data;
        })
        .catch(() => {
          this.cities = [];
        })
        .then(() => {
          this.loading = false;
        });
    },
    clearAddress() {
      this.address = null;
      this.submitted = false;
      this.unlistedAddress = false;
    },
    submit() {
      this.submitted = true;
    },
    submitUnlisted() {
      this.unlistedAddress = true;
      this.submitted = true;
    },
  },
  computed: {
    showUnlistedLink() {
      if (!this.address && !this.submitted) {
        if (this.city && this.city.wireless) {
          return false;
        }
        return true;
      }
      return false;
    },
    googleMapsApiKey() {
      return process.env.VUE_APP_GOOGLE_MAPS_EMBED_API_KEY;
    },
  },
  watch: {
    city() {
      if (this.city) {
        if (!this.city.wireless) {
          this.fetchAddresses();
        } else {
          this.address = null;
          this.addresses = [];
        }
      }
    },
  },
};
</script>
